/* eslint-env es6 */

export function c (pattern) {
    return '(' + pattern + ')';
}
export function nc (pattern) {
    return '(?:' + pattern + ')';
}
export function atLeastOne (pattern) {
    return pattern + '+';
}
export function atLeastNone (pattern) {
    return pattern + '*';
}
export function opt (pattern) {
    return pattern + '?';
}
export function oneOf () {
    if (_.isArray(arguments[0])) {
        return arguments[0].join('|');
    } else {
        return Array.prototype.join.call(arguments, '|');
    }
}
export function isA (pattern) {
    return '[' + pattern + ']';
}
export function notA (pattern) {
    return isA('^' + pattern);
}
export const wordBound       = '\\b';
export const nonWordBound    = '\\B';

export function escape (value) {
    return value.replace(/[-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}


// WEBPACK FOOTER //
// ./app/src/lib/re.es6